import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const SettingsFields = ({settings = {}, prefix = ''}) => {
  return (
    <Panes
      entity={settings}
      prefix={prefix}
      panes={[
        {
          title: 'General Settings',
          fields: [
            <TextField
              name="sender"
              prefix={prefix}
              label="Trigger Email Sender"
            />,
            <TextField
              name="accountFormURL"
              prefix={prefix}
              label="Account Form URL (use {{REFERENCE}} to indicate where the reference should go)"
            />,
            <TextField
              name="accountFormRecipients"
              prefix={prefix}
              label="Account Form Recipients (a comma-separated list of email addresses to receive completed forms)"
            />,
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
};

SettingsFields.getValues = ({sender, accountFormURL, accountFormRecipients}) => ({sender, accountFormURL, accountFormRecipients});

export default SettingsFields;
